var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    enableBackground: "new 0 0 144 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Travel_Planning"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Globe_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Map"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Flight_Date"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Alarm_Clock"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Small_Suitcase"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Backpack"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Large_Suitcase"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Toiletries"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Laptop"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Passport"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Taxi"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Signs"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Airport"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Wind_Sock"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Check-In"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Ticket"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Tag"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Escalator"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Body_Scanner"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Walking_with_Suitcase"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Gate_Number"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Seats"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Seat_Belt"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Take_Off"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Plane_Window"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "International_Travel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1109_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1118_",
    opacity: 0.1,
    d: "M114.169,81l5.596-3.224l3.445-23.589l7.131-4.111c1.338-0.771,4.559-5.578,3.418-7.548     c-1.141-1.97-6.923-1.593-8.261-0.822l-7.131,4.111L96.178,37l-5.596,3.224l17.483,11.529l-8.712,5.021l-6.246-2.091l-5.109,2.943     l8.296,6.491l1.484,10.416l5.109-2.943l1.31-6.446l8.712-5.021L114.169,81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1117_",
    opacity: 0.1,
    d: "M68.999,47c1.167-4.333-11.167-9.333-1-16l-0.151-0.805     C66.578,30.079,65.298,30,63.999,30c-16.321,0-30.457,9.316-37.409,22.914L26.999,53c5.667-4.833,20.139,4.408,15,12     c-7.333,10.833,1.702,11.618,10,11c4.5-0.5,9.944-2.619,8-13C58.311,53.984,67.832,51.333,68.999,47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1116_",
    opacity: 0.1,
    d: "M101.9,90.1c-4.708,5.103-8.798,2.369-11.901-2.1c-3.125-4.5-8.75-5-12,2     s-6.625,0.5-13,10c-6.131,9.137-0.471,13.647-0.03,13.978C81.269,113.607,95.27,103.958,101.9,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1115_",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "     M105.418,78.999C102.086,98.864,84.81,114,63.999,114c-23.196,0-42-18.804-42-42s18.804-42,42-42     c7.198,0,13.973,1.811,19.894,5.001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1114_",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "     M114.169,81l5.596-3.224l3.445-23.589l7.131-4.111c1.338-0.771,4.559-5.578,3.418-7.548c-1.141-1.97-6.923-1.593-8.261-0.822     l-7.131,4.111L96.178,37l-5.596,3.224l17.483,11.529l-8.712,5.021l-6.246-2.091l-5.109,2.943l8.296,6.491l1.484,10.416     l5.109-2.943l1.31-6.446l8.712-5.021L114.169,81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1113_",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "     M86.999,69C45.166,92.5,11.897,90.5,10.097,80c-0.834-4.867,3.85-10.019,11.8-15.066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1112_",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "     M67.999,31c-10.167,6.667,2.167,11.667,1,16c-1.167,4.333-10.688,6.984-9,16c1.944,10.381-3.5,12.5-8,13     c-8.298,0.618-17.333-0.167-10-11c5.139-7.592-9.333-16.833-15-12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1110_",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "     M64.999,114c0,0-6.375-4.5,0-14s9.75-3,13-10s8.875-6.5,12-2s7.25,7.25,12,2"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Meal"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Landing"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Shuttle_Bus"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Hotel"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Hotel_Check-In"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Valet_1_"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Baggage_Trolley"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Door_Hanger"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Hotel_Room"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Shower"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d819cdab786071dcbc2df19bcb4e7cee.svg";
export { ForwardRef as ReactComponent };